import * as React from 'react';
import * as styles from './styles.css';

import { Close12 } from '@cian/ui-kit/icons';
import { IBackToPageProps } from './types';

export function BackToPageMobile(props: IBackToPageProps) {
  return (
    <a href={props.href} className={styles['mobile']} onClick={props.onClick}>
      <Close12 />
    </a>
  );
}
